import { useEffect } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useTeam } from "../../../context/TeamContext";
import { ErrorMessage } from "../../../components/error-message";
import { UserRoles } from "../../../types/user.types";
import { Navigate } from "react-router-dom";
import { TMInfoPrimaryUser } from "../team-members-information/tm-info-primary-user";
import { TeamMembersInfoDisplay } from "../team-members-information/team-members-info-display";
import { Loading } from "../../../components/loading";
import bgRegisterMembers from "../../../assets/bgRegisterMembers.jpg";
import { Users } from "lucide-react";

export function MyMembers() {
  const { user } = useAuth();
  const { getTeam, isLoading, error, team } = useTeam();

  useEffect(() => {
    getTeam();
  }, [getTeam]);

  if (
    ![UserRoles.PRIMARY_USER, UserRoles.INVITED_USER].includes(user!.roleId)
  ) {
    return <Navigate to="/unauthorized" />;
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-cover bg-center relative overflow-hidden bg-fixed"
      style={{ backgroundImage: `url(${bgRegisterMembers})` }}
    >
      <div className="absolute inset-0 bg-black opacity-60 z-0" />

      <div className="relative w-[90%] md:w-[80%] lg:w-[70%] xl:w-[50%] max-w-4xl p-8 bg-[#F8F9FA] shadow-xl rounded-2xl bg-opacity-80 text-gray-900 border border-gray-300 z-10 my-4">
        <div className="flex items-center space-x-2 mb-6 justify-center">
          <Users className="h-6 w-6 text-gray-800" />
          <h1 className="text-2xl font-bold text-gray-800">Miembros</h1>
        </div>

        {error && <ErrorMessage message={error} dismissible />}

        {isLoading ? (
          <Loading />
        ) : team ? (
          <>
            {user?.roleId === UserRoles.PRIMARY_USER && (
              <TMInfoPrimaryUser team={team} />
            )}
            {user?.roleId === UserRoles.INVITED_USER && (
              <TeamMembersInfoDisplay team={team} />
            )}
          </>
        ) : null}
      </div>
    </div>
  );
}
